import 'twin.macro';
import React from 'react';
import OndeScreenshot from './onde_capture_ecran.png';
import { Trans, useTranslation } from 'react-i18next';

function Step({ numero, text }: { numero: number; text: any }) {
  const { t } = useTranslation(['common']);
  return (
    <div
      tw="pl-4 py-2 flex flex-col md:pl-0 md:pt-4 md:pb-0"
      aria-current="step"
    >
      <span tw="text-xs text-brand-intense font-bold tracking-wide uppercase">
        {t('common:components.ondeTuto.stepX', { nb: numero })}
      </span>
      <span>{text}</span>
    </div>
  );
}

export function OndeFileTuto() {
  const { t } = useTranslation(['common']);
  return (
    <div tw="relative py-16 overflow-hidden">
      <div tw="relative px-4 sm:px-6 lg:px-8">
        <div tw="text-lg max-w-prose mx-auto">
          <h1>
            <span tw="block text-base text-center text-brand-intense font-semibold tracking-wide uppercase">
              {t('common:components.ondeTuto.tutorial')}
            </span>
            <span tw="mt-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-neutral-intense sm:text-4xl">
              {t('common:components.ondeTuto.title')}
            </span>
          </h1>
        </div>
        <div tw="mt-6 prose prose-lg text-neutral-quiet mx-auto">
          <p tw="mb-2">{t('common:components.ondeTuto.step0_intro')}</p>
          <Step numero={1} text={t('common:components.ondeTuto.step1')} />
          <Step
            numero={2}
            text={
              <Trans i18nKey="common:components.ondeTuto.step2">
                __A__<i tw="font-bold">__B__</i>
              </Trans>
            }
          />
          <Step
            numero={3}
            text={
              <Trans i18nKey="common:components.ondeTuto.step3">
                __A__<i tw="font-bold">__B__</i>__C__
                <i>__D__</i>
              </Trans>
            }
          />
          <Step numero={4} text={t('common:components.ondeTuto.step4')} />
          <Step numero={5} text={t('common:components.ondeTuto.step5')} />
          <Step
            numero={6}
            text={
              <Trans i18nKey="common:components.ondeTuto.step6">
                __A__
                <i tw="font-bold">__B__</i>__C__
              </Trans>
            }
          />
          <div tw="text-center">
            <img
              alt="Onde capture d'écran"
              tw="inline-block"
              src={OndeScreenshot}
            />
          </div>

          <p>{t('common:components.ondeTuto.final')}</p>
        </div>
      </div>
    </div>
  );
}
